import { render, staticRenderFns } from "./FaultyMetersCard.vue?vue&type=template&id=f2961cb8&scoped=true&"
import script from "./FaultyMetersCard.vue?vue&type=script&lang=js&"
export * from "./FaultyMetersCard.vue?vue&type=script&lang=js&"
import style0 from "./FaultyMetersCard.vue?vue&type=style&index=0&id=f2961cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2961cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VDataTable,VDivider,VProgressLinear,VRow})
